
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class Footer extends Vue {
  anio = new Date().getFullYear();

  created() {
    window.addEventListener("resize", (this as any).$root.handleResize);
    (this as any).$root.handleResize();
  }

  destroyed() {
    window.removeEventListener("resize", (this as any).$root.handleResize);
  }
}
